import React from 'react';
import { Field } from 'redux-form';
import { Form, Row, Col, Button } from 'antd';
import AntIcon from '../../shared/components/AntIcon';

import {
  formItemLayout,
  formItemLayoutWithoutLabel,
  renderInput,
} from '../../shared/utils/form_components';
import { required, url } from '../../shared/utils/form_validations';

const ImageFields = ({ fields, label }) => {
  return (
    <div>
      {fields.map((imageUrl, index, fields) => {
        return (
          <Form.Item
            {...(index === 0 ? formItemLayout : formItemLayoutWithoutLabel)}
            key={imageUrl}
            label={index === 0 ? label : null}
          >
            <Row gutter={16}>
              <Col span={22}>
                <Field
                  inputOnly
                  name={imageUrl}
                  placeholder="Link"
                  component={renderInput}
                  validate={[required, url]}
                />
              </Col>
              <Col className="is-right">
                <AntIcon
                  type="minus-circle-o"
                  onClick={() => fields.remove(index)}
                  style={{ cursor: 'pointer', color: 'red' }}
                />
              </Col>
            </Row>
          </Form.Item>
      )})}

      <Form.Item
        {...(fields.length === 0 ? formItemLayout : formItemLayoutWithoutLabel)}
        label={fields.length === 0 ? label : null}
      >
        <Button type="dashed" onClick={() => fields.push("")} style={{ width: '60%' }}>
          <AntIcon type="plus" />Add Url
        </Button>
      </Form.Item>
    </div>
  );
}

export default ImageFields;